<script>
export default {
  name: 'UlFormDatePicker',
  props: {
    value: {},
    min: {
      type: Date,
      default: () => new Date(1900, 1, 1),
    },
    max: {
      type: Date,
      default: () => new Date(2099, 1, 1),
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate,
      },
    };
  },
  methods: {
    disabledDate(date) {
      const time = date.getTime();
      if (time > this.max.getTime()) {
        return true;
      }
      if (time < this.min.getTime()) {
        return true;
      }
      return false;
    },
  },
};
</script>
<template>
  <div class="ul-form-date-picker" :class="{'ul-form-date-picker--left': left}">
    <UlFormDate
      :value="value"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @submit="$emit('submit', $event)"
    />
    <div class="ul-form-date-picker__icon">
      <el-date-picker
        :value="value"
        format="dd.MM.yyyy"
        :disabled="disabled"
        :picker-options="pickerOptions"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        @keypress.enter="submit"
        :clearable="false"
        popper-class="ul-form-date-picker__popper"
      />
    </div>
  </div>
</template>
<style lang="scss">
  .ul-form-date-picker {
    display: flex;

    &__icon {
      margin: 0 0 0 4px;
      flex-shrink: 0;
      width: 28px;
    }

    .ul-form-date {
      flex: 1;
    }

    .ul-form-btn {
      flex-shrink: 0;
    }

    .el-date-editor {
      width: 100% !important;
      height: 100%;

      .el-input__inner {
        display: none;
      }

      .el-input__icon {
        line-height: 28px;
      }

      .el-input__prefix {
        cursor: pointer;
        position: static;
        display: block;
        height: 28px;
        border-radius: 50%;
        width: 100%;
        color: #333333;

        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        &:active {
          background-color: rgba(0, 0, 0, .1);
        }

        &:focus {
          background-color: rgba(0, 0, 0, .12);
        }
      }
    }

    &__popper {
      .popper__arrow {
        transform: translateX(-30px);
      }
    }

    &--left {
      .ul-form-date-picker__icon {
        order: 1;
        margin: 0 4px 0 0;
      }

      .ul-form-date {
        order: 2;
      }
    }
  }
</style>
